export default "__VITE_ASSET__68ad4f7b__"